import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ContactForm from "../components/ContactForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';

const ContactPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F8F6FB] via-[#F5F0FA] to-[#F0EBF8] dark:from-[#1A0730] dark:via-[#2D0C4B] dark:to-[#1A0730] py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header with Back Button */}
        <div className="flex justify-start items-center mb-6">
          <Button 
            onClick={() => navigate('/')}
            variant="outline"
            className="flex items-center gap-2 bg-gradient-to-r from-[#6B3FA0] to-[#8A4FDB] text-white border-0 hover:from-[#5E2D9E] hover:to-[#7C4DCC]"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('back')}
          </Button>
        </div>

        {/* Contact Form */}
        <ContactForm />
      </div>
    </div>
  );
};

export default ContactPage;
